import React, { useRef } from 'react';
import { MdAdd } from 'react-icons/md';

import { t } from '@i18n/index';
import { IOrder } from '@hooks/useCurrentOrder/models';
import Modal, { IModalRef } from '@components/Modal';
import findValidCharge from '@util/findValidCharge';
import ManualIntegrationModal from './ManualIntegrationModal';

import { ManualIntegrationContainer, IntegrationButton } from './styles';

const ManualIntegration: React.FC<{
  order?: IOrder;
  refetch?: () => Promise<void>;
}> = ({ order, refetch }) => {
  const manualIntegrationModalRef = useRef<IModalRef>(null);

  const orderWithCharges = findValidCharge(order);

  return (
    <ManualIntegrationContainer>
      <IntegrationButton
        variant="outlined"
        noFullWidth
        startIcon={orderWithCharges ? <MdAdd /> : null}
        onClick={() => {
          manualIntegrationModalRef?.current?.show();
        }}
      >
        {orderWithCharges ? (
          <>{t('@orders/MANUAL_INTEGRATION', 'Integrar Cobrança')}</>
        ) : (
          <>{t('@orders/MANUAL_INTEGRATION', 'Integração Manual')}</>
        )}
      </IntegrationButton>

      <Modal ref={manualIntegrationModalRef} size="small">
        {order?.order && (
          <ManualIntegrationModal
            order={order.order}
            hide={() => {
              manualIntegrationModalRef.current?.hide();
            }}
            refetch={refetch}
          />
        )}
      </Modal>
    </ManualIntegrationContainer>
  );
};

export default ManualIntegration;
